module.exports = __webpack_public_path__ + "media/components/country-flag/static/cz-c488652656f9ec9a97f380f40d155236.svg";